export const getters = {
    model: state => state.model,
    conclusionLogoModel: state => state.conclusion_logo_model,
    columns: state => state.columns,
    rules: state => state.rules,
    phone_numbers: state => state.phone_numbers,
};
